// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fcbaba7a","239":"a754c92a","453":"7ef412fa","667":"0caf04b2"}[chunkId] + ".chunk.js";
};